/**
 * Protected Layout
 * Layout for authenticated user pages with auth guard
 */

import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@schoolidb/store';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ToastContainer } from '../components/ToastContainer';

export function ProtectedLayout() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const status = useAuthStore((state) => state.status);

  // Show loading while checking auth
  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header />
      <main className="flex-1 container-app py-8">
        <Outlet />
      </main>
      <Footer />
      <ToastContainer />
    </div>
  );
}
